import Controller from "./invoiceItem.controller";
import template from "./invoiceItem.html";

const invoiceItem = {
  template,
  controller: Controller,
};

export default invoiceItem;



// WEBPACK FOOTER //
// ./src/pages/invoiceItem/invoiceItem.component.js